import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import AudioPlayer from './AudioPlayer';
import registerServiceWorker from './registerServiceWorker';

const songs = [
  {
    url: 'https://s3.us-east-2.amazonaws.com/est.unhype.me/est/canyons.m4a',
    cover: 'https://s3.us-east-2.amazonaws.com/est.unhype.me/est/yourfakenoise.png',
    artist: {
      name: 'EST',
      song: '1. Canyons'
    }
  },
];

ReactDOM.render(<AudioPlayer songs={songs} />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js